import { Grid } from "@material-ui/core";
import React from "react";
import ContainedLabel from "./ContainedLabel";
import "./gridControls.scss";
import DMSelect from "../DMSelect";
import AntSwitch from "../AntSwitch";
import GridActionItem from "./GridActionItem";
import GridSelect from "./GridSelect";
import DMSwitch from "./DMSwitch";
import MultiValueLabels from "./MultiValueLabels";
import DraggableContainedLabel from "./DraggableContainedLabel";
import GridLabel from "./GridLabel";
import DropdownSelect from "../DropDownSelect";
import UserGridLabel from "./UserGridLabel";
import FirstColumnPointer from "./FirstColumnPointer";

const GridItem = (props) => {
  const getColumnControls = (col) => {
    switch (col.colType) {
      case "grid-label":
        return <GridLabel {...col.colOptions} />;
      case "user-grid-label":
        return <UserGridLabel {...col.colOptions} />;
      case "first-column-pointer":
        return <FirstColumnPointer {...col.colOptions} />; 
      case "draggable-contained-label":
        return <DraggableContainedLabel {...col.colOptions} />;
      case "contained-label":
        return <ContainedLabel {...col.colOptions} />;
      // case 'grid-select':
      //     return <GridSelect {...col.colOptions} />
      case "grid-select":
        return <DropdownSelect {...col.colOptions} />;
      case "ant-switch":
        return <DMSwitch {...col.colOptions} />;
      case "multiple-values":
        return <MultiValueLabels {...col.colOptions} />;
      case "grid-actions":
        return <GridActionItem items={col.colOptions} />;
      default:
        break;
    }
  };

  return (
    <div
      id={props?.key}
      className={`grid-item-container ${props.className} ${props.highlight}`}
      key={props?.key}
    >
      {props.items.map((i) => {
        return <div className={`grid-item`}>{getColumnControls(i)}</div>;
      })}
    </div>
  );
};

export default GridItem;
